// extracted by mini-css-extract-plugin
module.exports = {"aboutus":"About_aboutus__3lmPG","cards":"About_cards__3xOnI"};